import { DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
	ItModalComponent,
	ItListComponent,
	ItListItemComponent,
	ItIconComponent,
	ItButtonDirective,
	ItCheckboxComponent,
	ItBadgeDirective,
} from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import type { Authority } from '../interfaces/authority';
import type { Dossier } from '../interfaces/dossier';
import type { Notification } from '../interfaces/notification';

@Component({
	selector: 'app-notifications',
	imports: [
		ItModalComponent,
		ItListComponent,
		ItListItemComponent,
		ItIconComponent,
		ItButtonDirective,
		ItCheckboxComponent,
		ItBadgeDirective,
		TranslateModule,
		DatePipe,
	],
	templateUrl: './notifications.component.html',
	styleUrl: './notifications.component.scss',
})
export class NotificationsComponent implements OnInit {
	private iterlexService = inject(IterlexService);

	@Input({ required: true }) authority!: Authority;
	@Input({ required: true }) body!: Authority;
	@Input() dossier?: Dossier;
	notifications: Notification[] = [];
	showArchivedNotifications = false;
	ngOnInit(): void {
		this.updateNotifications();
	}
	updateNotifications() {
		this.iterlexService
			.getNotifications(
				this.authority.id,
				this.body.id,
				this.showArchivedNotifications,
				this.dossier?.workUri,
			)
			.subscribe(
				(notifications) => (this.notifications = notifications.value),
			);
	}
	unreadNotificationCount() {
		return this.notifications.filter((n) => !n.read).length;
	}
	markNotificationAsRead(notification: Notification) {
		this.iterlexService
			.editNotification(
				this.authority!.id,
				this.body!.id,
				notification.id,
				true,
				notification.archived,
			)
			.subscribe(() => (notification.read = true));
	}
	markNotificationAsArchived(notification: Notification) {
		this.iterlexService
			.editNotification(
				this.authority!.id,
				this.body!.id,
				notification.id,
				notification.read,
				true,
			)
			.subscribe(() => {
				notification.archived = true;
				this.updateNotifications();
			});
	}
}
